"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertInstance = void 0;
// eslint-disable-next-line import/prefer-default-export
var alert_instance_1 = require("./alert-instance");
Object.defineProperty(exports, "AlertInstance", { enumerable: true, get: function () { return __importDefault(alert_instance_1).default; } });
